import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";

const initialFValues = {
  id: 0,
  name: "",
  contact_info: "",
  payment_terms: "",
  rating: 0,
};

export default function EditSupplierForm(props) {
  const { addOrEdit, recordForEdit } = props;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("name" in fieldValues)
      temp.name = fieldValues.name ? "" : "This field is required.";
    if ("contact_info" in fieldValues)
      temp.contact_info = fieldValues.contact_info
        ? ""
        : "This field is required.";
    if ("payment_terms" in fieldValues)
      temp.payment_terms = fieldValues.payment_terms
        ? ""
        : "This field is required.";

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var result = {
        ...values,
      };
      addOrEdit(result, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  const [holdBtn, setHoldBtn] = useState(true);

  useEffect(() => {
    const { rating, ...requiredValues } = values;
    const allValuesFilled = Object.values(requiredValues).every(
      (value) => value !== "" && value !== null && value !== undefined
    );

    setHoldBtn(!allValuesFilled);
  }, [values]);

  const paymentTerms = [
    { title: "Net 0", id: "Net 0" },
    { title: "Net 30", id: "Net 30" },
    { title: "Net 60", id: "Net 60" },
    { title: "Net 90", id: "Net 90" },
    { title: "Net 120", id: "Net 120" },
    { title: "Net 180", id: "Net 180" },
  ];

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="name"
            label="Name*"
            value={values.name || ""}
            onChange={handleInputChange}
            error={errors.name}
          />
          <Controls.Input
            label="Contact Info (Phone, email, address)"
            name="contact_info"
            value={values.contact_info || ""}
            onChange={handleInputChange}
            error={errors.contact_info}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Select
            label="Payment Terms (e.g. Net 30, Net 60)*"
            name="payment_terms"
            value={values.payment_terms || ""}
            options={paymentTerms}
            onChange={handleInputChange}
            error={errors.payment_terms}
          />
          <Controls.Input
            label="Rating*"
            name="rating"
            value={values.rating || "0"}
            onChange={handleInputChange}
            error={errors.rating}
          />
          <div>
            <Controls.Button disabled={holdBtn} type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
